import { Component, OnChanges, Input } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { DatePipe } from '@angular/common';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-observe-protocol-observationHeading',
  templateUrl: './ph-bhp-observe-protocol-observationHeading.component.html',
  styleUrls: ['./ph-bhp-observe-protocol-observationHeading.component.css'],
  providers: [DatePipe]
})
export class PhBhpObserveProtocolObservationHeadingComponent implements OnChanges {
  @Input() modalRef;
  @Input() selecteddept;
  @Input() selectedward;
  @Input() sessionName;
  @Input() totalNumberOfObservations;
  @Input() startDateTime;
  @Input() endDateTime;

  @Input() totalQuota;
  @Input() quotaId;
  @Input() quotaStartDateTime;
  @Input() quotaEndDateTime;
  @Input() quotaDaysLeft; 
  @Input() observedQuota;
  @Input() numberOfDays;

  dateString:string = "";
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(private datePipe: DatePipe, public layoutService: PHBHPLayoutPackageService) { }
  
  ngOnChanges() {
    if(this.startDateTime && this.endDateTime){
      // this.dateString = this.datePipe.transform(this.data.convertUTCStingToLocalDate(this.startDateTime), 'MMM dd, yyyy | hh:mm a');
      // this.dateString += this.datePipe.transform(this.data.convertUTCStingToLocalDate(this.endDateTime), ' -  hh:mm a');
      const lang = localStorage.getItem('selectedlanguage');
      this.dateString = `${this.dateFormat(this.layoutService.convertUTCStingToLocalDate(this.startDateTime))}
       | ${this.timeFormat(this.layoutService.convertUTCStingToLocalDate(this.startDateTime))}
       - ${this.timeFormat(this.layoutService.convertUTCStingToLocalDate(this.endDateTime))}`;
    }
  }  

  dateFormat(date) {
    const newDate = this.layoutService.convertUTCStingToLocalDate(date);
    const lang = localStorage.getItem('selectedlanguage');
    return newDate.toLocaleDateString(lang, { weekday: 'long', month: "long", day: "numeric", year: "numeric" });
  }

  timeFormat(time) {
    const lang = localStorage.getItem('selectedlanguage');
    return time.toLocaleTimeString(lang, { hour12: false, hour: '2-digit', minute: '2-digit' });
  }
}
